'use client';

import { HorizontalEventCard } from '@goodneighbor/ui';
import styles from './registrationComplete.module.scss';
import { parseForEventCardProps } from '@/services/event';
import { Event } from '@goodneighbor/api/schemas/events/event.schema';
import CancellationCard from '../CancellationCard';

export default function RegistrationComplete({
  event,
  organizationName
}: {
  event: Event;
  organizationName: string;
}) {
  return (
    <div className={styles.registrationComplete}>
      <HorizontalEventCard
        {...parseForEventCardProps(event, organizationName)}
      />
      <CancellationCard />
    </div>
  );
}
